import axios, { AxiosError } from 'axios';
import { ApiFinanceira } from '../axiosfinanceiro';

interface ContasPagar {
  dataemissao: Date;
  vencimento: Date;
  nome: string;
  cpf: string;
  historico: string;
  fazenda: string;
  numerodoc: string;
  valorparcela: number;
  acrescimo: number;
  valorpago: number;
  desconto: number;
  valorpagar: number;
}

interface IParceirosPagar {
  idparceiro: string;
  nome: string;
  cpf: string;
  valorparcela: number; 
  acrescimo: number;
  valorpago: number;
  desconto: number; 
  valorpagar: number;
}

interface IVencPagar {
  vencimento: Date;
  valorparcela: number; 
  acrescimo: number;   
  valorpago: number;
  desconto: number; 
  valorpagar: number;
}

export interface ICompras {
  dataemissao: Date;
  numerodoc: string;
  nome: string;
  cpf: string;
  historico: string;
  descricao: string;
  valornota: number;
  desconto: number;
  acrescimo: number;
  total: number;
}

interface EntryPagar {
  contas: IParceirosPagar;
  contaspagar: ContasPagar[];
}

interface EntryPagarVenc {
  contas: IVencPagar;
  contaspagar: ContasPagar[];
}

interface ErrorResponse {
  error: {
    default: string;
  };
}


const RelatorioContasPagar = async (parceiro: string, fazenda: string, planoconta: string, datainicial: string, datafinal: string): Promise<ContasPagar[] | Error> => {
  try {
    const urlRelativa = `/relatoriocontaspagar?fazenda=${fazenda}&parceiro=${parceiro}&agrupar=${'nao'}&planoconta=${planoconta}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RelatorioContasPagarAgrupadoParceiro = async (parceiro: string, fazenda: string, agrupar: string, planoconta: string, datainicial: string, datafinal: string): Promise<EntryPagar[] | Error> => {
  try {
    const urlRelativa = `/relatoriocontaspagar?fazenda=${fazenda}&parceiro=${parceiro}&agrupar=${agrupar}&planoconta=${planoconta}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RelatorioContasPagarAgrupadoVencimento = async (parceiro: string, fazenda: string, agrupar: string, planoconta: string, datainicial: string, datafinal: string): Promise<EntryPagarVenc[] | Error> => {
  try {
    const urlRelativa = `/relatoriocontaspagar?fazenda=${fazenda}&parceiro=${parceiro}&agrupar=${agrupar}&planoconta=${planoconta}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    } 
  }
};


const RelatorioCompras = async (parceiro: string, planoconta: string, idfazenda: string, datainicial: string, datafinal: string): Promise<ICompras[] | Error> => {
  try {
    const urlRelativa = `/compras?parceiro=${parceiro}&planoconta=${planoconta}&idfazenda=${idfazenda}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const RelatorioContasPagarService = {
  RelatorioContasPagar,
  RelatorioContasPagarAgrupadoParceiro,
  RelatorioContasPagarAgrupadoVencimento,
  RelatorioCompras,
};